import React from 'react';
import { communityImages, foodBankImages, supplierImages, volunteerImages } from '../assets/images';

const ImageDebug: React.FC = () => {
  const testImages = [
    { name: 'Food Bank', url: foodBankImages.foodBankOfEnc },
    { name: 'Supplier', url: supplierImages.wholeFoods },
    { name: 'Volunteer', url: volunteerImages.me },
    { name: 'Community 1', url: communityImages.communityGathering2 },
    { name: 'Community 2', url: communityImages.communityGathering6 },
  ];

  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">🖼️ Image Debug Component</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testImages.map((image, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow">
            <h3 className="font-semibold mb-2">{image.name}</h3>
            <p className="text-sm text-gray-600 mb-2 break-all">
              URL: {image.url}
            </p>
            <div className="border-2 border-dashed border-gray-300 p-4 rounded">
              <img
                src={image.url}
                alt={image.name}
                className="max-w-full h-48 object-cover mx-auto"
                onLoad={() => console.log(`✅ ${image.name} loaded successfully`)}
                onError={(e) => {
                  console.error(`❌ ${image.name} failed to load:`, e);
                  console.error('URL:', image.url);
                }}
              />
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
        <h3 className="font-semibold mb-2">🔍 Debug Info:</h3>
        <p className="text-sm">
          <strong>Environment:</strong> {import.meta.env.MODE}<br/>
          <strong>Production:</strong> {import.meta.env.PROD ? 'Yes' : 'No'}<br/>
          <strong>Base URL:</strong> {import.meta.env.PROD ? 'Railway' : 'Local'}
        </p>
      </div>
    </div>
  );
};

export default ImageDebug;
